import { Map, List } from 'immutable';
import defaultDialogReducer from '../defaultDialogReducer';
import {dialogsNames} from '../../enums/dialogsNames';
import { actionTypes as actionTypes }  from '../../actions/LocationPage/CuttingView/reportCutDialogActions';


let defaultState = {
  show: false,
  loading: false,
  preselectedAssets: List(),
  dialogData: null,
  allowRollSelection: false,

  // Why the footer checkbox is on screen, when it is (SAAS-25063). The dialog has one checkbox and
  // two things it can mean - "ignore the server's business validation warnings" (the original) and
  // "report without SAP verification" - and they must not be confused: the first travels to the
  // server as ignoreValidationWarnings and is permission-checked there, the second never leaves the
  // client. See reportCutDialog.onSubmit.
  sapVerificationFailed: false
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {

    case actionTypes.REPORT_CUT_DIALOG_SHOW:
      return state.set('preselectedAssets', action.payload && action.payload.preselectedAssets ?
                        action.payload.preselectedAssets.map((item) => _convertRollDataToDialogItem(item)) : List())
                  .set('allowRollSelection', action.payload.allowRollSelection)
                  .set('show', true);

    case actionTypes.REPORT_CUT_DIALOG_ROLL_CHANGED:
      return state.set('preselectedAssets', List([_convertRollDataToDialogItem(action?.payload || {})]))
                  .set('show', true);

    case actionTypes.REPORT_CUT_DIALOG_SAP_VERIFICATION_FAILED:
      return state.set('sapVerificationFailed', true);

    // Any edit to the form invalidates the verdict we are holding - the confirmation number itself
    // may be what just changed - so the override goes away with the checkbox that carried it.
    // dialogHelper.onFormChangeHandler fires this on the first change after a failure; the shared
    // reducer below then clears the checkbox and the error state.
    case actionTypes.REPORT_CUT_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return defaultDialogReducer(
        state.set('sapVerificationFailed', false), 
        action,
        dialogsNames.REPORT_CUT_DIALOG, 
        defaultState
      );

    default:
      return defaultDialogReducer(state, action, dialogsNames.REPORT_CUT_DIALOG, defaultState);
  }
}

////////////////////////////////////////////////////
function _convertRollDataToDialogItem(item) {
  return {
    // ROLL DATA FROM GRID.
    rollId:         item.id,
    rollBusinessId: item.businessId,
    rollLengthLeft: item.lengthLeft,
    weight: item.weight ? item.weight : 0,
    rollMaterial:   item.material?.businessId,
    rollMaterialName:   item.material?.materialName,
    rollProjectId:    item.project ? item.project.id : null,
    affectedWos: item?.affectedWos || [],
    kitTypeId: item?.kitTypeId,

    // FORM INPUT PLACEHOLDERS.
    cutLength:      null,
    numberOfPlies:  null,
    cutNests:       [],
    notes:          null
  };
}






